import {Component, ViewChild} from '@angular/core';
import {Content, IonicPage, Keyboard, ModalController, NavController, NavParams} from 'ionic-angular';
import {IntroWizardServiceProvider} from "../../providers/intro-wizard-service/intro-wizard-service";
import {IntroInsurranceValidationPage} from "../intro-insurrance-validation/intro-insurrance-validation";
import {IntroChooseInsurranceCompanyPage} from "../intro-choose-insurrance-company/intro-choose-insurrance-company";
import {LoginPage} from "../login/login";
import {StatusBar} from "@ionic-native/status-bar";
import {Subscription} from "rxjs";
import {ModalTeamInfoPage} from "../modal-team-info/modal-team-info";
import {RegisterPage} from "../register/register";
import {InitHelloPage} from "../init-hello/init-hello";
import {ApiProvider} from "../../providers/api/api";
import {UserStateProvider} from "../../providers/user-state/user-state";

/**
 * Generated class for the IntroNamePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-intro-name',
  templateUrl: 'intro-name.html',
})
export class IntroNamePage {
  @ViewChild(Content) public content: Content;

  loginPage: any = LoginPage;
  errorVisible: boolean = false;

  keyboardShowCallback: Subscription;
  keyboardDidShowCallback: Subscription;
  keyboardHideCallback: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public introWizard: IntroWizardServiceProvider,
    private keyboard: Keyboard,
    public statusBar: StatusBar,
    public modalCtrl: ModalController,
    private api: ApiProvider,
    private userState: UserStateProvider
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IntroNamePage');

    var me = this;

    this.keyboardShowCallback = this.keyboard.willShow.subscribe(function () {
      me.statusBar.hide();
    }, () => {
    }, () => {
      me.content.scrollToBottom();
    });

    this.keyboardDidShowCallback = this.keyboard.didShow.subscribe(function () {
      setTimeout(() => {
        me.content.scrollToBottom();
      }, 50);
    });

    this.keyboardHideCallback = this.keyboard.willHide.subscribe(function () {
      me.statusBar.show();
    });
  }

  ionViewDidLeave() {
    this.keyboardShowCallback.unsubscribe();
    this.keyboardHideCallback.unsubscribe();
    this.keyboardDidShowCallback.unsubscribe();
  }

  hideError() {
    this.errorVisible = false;
  }

  showAuthorInfo() {
    let modal = this.modalCtrl.create(ModalTeamInfoPage);
    modal.present();
  }

  nextStep() {
    if (this.introWizard.firstName) {
      this.userState.user.firstName = this.introWizard.firstName;
      this.api.callPut('/users/' + this.userState.user.id, {firstName: this.introWizard.firstName}).subscribe((res: any) => {
      }, () => {
        this.navCtrl.pop();
      })

      this.navCtrl.push(InitHelloPage);
    } else {
      this.errorVisible = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/intro-name/intro-name.ts